

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export const initTimetrackingTable = () => {

    const accessToken = getCookie('drfToken');
    if (!accessToken) {
        console.error('Kein Token gefunden!');
        return;
    }

    var availableHeight = $(window).height() - $('body').offset().top;
    function setTableHeight() {
        const table = $('#timetrackingViewTable').DataTable({
            processing: true,
            serverSide: true,
            searching: true,
            responsive: true,
            scrollY: availableHeight - 335,
            ajax: {
                url: '/api/timetracking/work-entry-summary/',
                headers: {
                    'Authorization': `Token ${accessToken}`
                },
                dataSrc: function(json) {
                    return json.data;
                },
            },
            columns: [
                {data: 'employee', title: 'Mitarbeiter'},
                {data: 'start_time', title: 'Startzeit'},
                {data: 'end_time', title: 'Endzeit'},
                {
                    data: 'pause_duration',
                    title: 'Pausenzeit',
                    render: (data, type) => {
                      if (type === 'display' && data) {
                        return data.split('.')[0];
                      }
                      return data;
                    }
                },
                {
                    data: 'total_worked_time',
                    title: 'Gearbeitete Zeit',
                    render: (data, type) => {
                      if (type === 'display' && data) {
                        return data.split('.')[0];
                      }
                      return data;
                    }
                }
            ],
            language: {
                "decimal":        ",",
                "emptyTable":    "Keine Daten verfügbar",
                "info":          "_START_ bis _END_ von _TOTAL_ Einträgen",
                "infoEmpty":     "0 bis 0 von 0 Einträgen",
                "infoFiltered":  "(gefiltert von _MAX_ Einträgen)",
                "lengthMenu":    "_MENU_ Einträge anzeigen",
                "loadingRecords": "Lädt...",
                "processing":    "Bitte warten...",
                "search":        "Suchen:",
                "zeroRecords":   "Keine passenden Einträge gefunden",
                'paginate': {
                    'next': '<i class="fas fa-angle-right"></i>',
                    'previous': '<i class="fas fa-angle-left"></i>',
                    'first': '<i class="fas fa-angle-double-left"></i>',
                    'last': '<i class="fas fa-angle-double-right"></i>'
                }
            },
            "createdRow": function(row, data, dataIndex) {
                const url = `/timetracking/timetracking-update-view/${data.id}/`;
                $(row).addClass('clickable-row')
                     .attr('data-url', url)
                     .css('cursor', 'pointer');
            }
        });
    }
    setTableHeight();
    $(window).resize(function() {
        table.columns.adjust().draw();
    });
    $(document).on('click', '.clickable-row', function() {
        window.location.href = $(this).data('url');
    });
}



export const initWorkLogTable = () => {

    const accessToken = getCookie('drfToken');
    if (!accessToken) {
        console.error('Kein Token gefunden!');
        return;
    }

    if ($.fn.DataTable.isDataTable('#workLogTable')) {
        $('#workLogTable').DataTable().clear().destroy();
    }

    $('#workLogTable').DataTable({
        processing: true,
        serverSide: true,
        searching: true,
        responsive: true,
        ajax: {
            url: `/api/timetracking/${instanceId}/work-log-summary/`,
            headers: {
                'Authorization': `Token ${accessToken}`
            },
            dataSrc: function(json) {
                return json.data;
            },
            error: function(xhr, error, code) {
                console.log("Ajax error: " + error);
            },
        },
        columns: [
            { data: 'user' },
            { data: 'started_at' },
            { data: 'ended_at' },
            { 
                data: 'is_active',
                orderable: false,
                searchable: false,
                render: function(active) {
                    if (active) {
                    return '<span class="dot dot-green"></span>';
                    }
                    return '<span class="dot dot-grey"></span>';
                }
            }
        ],
        order: [[0, 'desc']],
        language: {
            "decimal":        ",",
            "emptyTable":    "Keine Daten verfügbar",
            "info":          "_START_ bis _END_ von _TOTAL_ Einträgen",
            "infoEmpty":     "0 bis 0 von 0 Einträgen",
            "infoFiltered":  "(gefiltert von _MAX_ Einträgen)",
            "lengthMenu":    "_MENU_ Einträge anzeigen",
            "loadingRecords": "Lädt...",
            "processing":    "Bitte warten...",
            "search":        "Suchen:",
            "zeroRecords":   "Keine passenden Einträge gefunden",
            'paginate': {
                'next': '<i class="fas fa-angle-right"></i>',
                'previous': '<i class="fas fa-angle-left"></i>',
                'first': '<i class="fas fa-angle-double-left"></i>',
                'last': '<i class="fas fa-angle-double-right"></i>'
            }
        },
    });
    
}

let currentWorkLogId = null;

async function fetchActiveWorkLog() {
    try {
        const accessToken = getCookie('drfToken');
        const response = await fetch(`/api/timetracking/active-work-log/?user_id=${userId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${accessToken}`,
            }
        });
        const data = await response.json();
        currentWorkLogId = data.id || null;
        console.log('Aktiver Arbeitsvorgang gefunden:', currentWorkLogId);
        initButtons();
        updateButtonState();
    } catch (error) {
        console.error('Fehler beim Abruf:', error);
    }
}


function updateButtonState() {
    const comeBtn = document.querySelector('#comeBtn');
    const goBtn = document.querySelector('#goBtn');
    if (currentWorkLogId) {
        // Falls ein Arbeitsvorgang aktiv ist, verstecke den "Kommen"-Button
        comeBtn.style.display = 'none';
        goBtn.style.display = 'inline-block';
    } else {
        // Andernfalls wird nur der "Kommen"-Button angezeigt
        comeBtn.style.display = 'inline-block';
        goBtn.style.display = 'none';
    }
}


function initButtons() {

    const accessToken = getCookie('drfToken');

    const comeBtn = document.querySelector('#comeBtn');
    const goBtn = document.querySelector('#goBtn');

    comeBtn.addEventListener('click', () => {
        if (currentWorkLogId) {
            console.log('Ein aktiver Arbeitsvorgang besteht bereits.');
            return;
        }
        fetch('/api/timetracking/start-work/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${accessToken}`,
          },
          body: JSON.stringify({ user_id: userId })
        })
        .then(res => res.json())
        .then(data => {
          if (data.id) {
            currentWorkLogId = data.id;
            console.log('Arbeitsbeginn gestartet:', data);
            updateButtonState();
          } else {
            console.error('Fehler beim Start:', data.error);
          }
        })
        .catch(error => console.error('Fehler:', error));
    });

    goBtn.addEventListener('click', () => {
        if (!currentWorkLogId) {
            console.log('Kein aktiver Arbeitsvorgang vorhanden.');
            return;
        }
        fetch('/api/timetracking/end-work/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${accessToken}`,
            },
            body: JSON.stringify({ work_log_id: currentWorkLogId })
          })
          .then(res => res.json())
          .then(data => {
            console.log('Arbeitsvorgang beendet:', data);
            currentWorkLogId = null;
            updateButtonState();
          })
          .catch(error => console.error('Fehler:', error));
    });
}


function startClock() {
    const clockElement = document.getElementById('clock');
    if (!clockElement) return;
    setInterval(() => {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        clockElement.textContent = `${hours}:${minutes}:${seconds} Uhr`;
    }, 1000);
}

export const initTimetrackingBtn = async () => {
    await fetchActiveWorkLog();
    startClock();
};
